import { ExternalPartner } from '@amzn/red-velvet-api';

export const PARTNER_OPTIONS = [
  { value: ExternalPartner.NONE, labelKey: 'teamPartnershipStep.partner_none' },
  { value: ExternalPartner.VISIT, labelKey: 'teamPartnershipStep.partner_visit' },
  { value: ExternalPartner.GOODERA, labelKey: 'teamPartnershipStep.partner_goodera' },
  { value: ExternalPartner.TAPROOT, labelKey: 'teamPartnershipStep.partner_taproot' },
  { value: ExternalPartner.OTHER, labelKey: 'teamPartnershipStep.partner_other' },
] as const;
